export const ACTION = {
  REQUEST_COPY_RISK_EVALUATION: 'REQUEST_COPY_RISK_EVALUATION',
  RECEIVE_COPY_RISK_EVALUATION: 'RECEIVE_COPY_RISK_EVALUATION',
  FAIL_REQUEST_COPY_RISK_EVALUATION: 'FAIL_REQUEST_COPY_RISK_EVALUATION'
};

export class RequestCopyRiskEvaluation {
  public type: string = ACTION.REQUEST_COPY_RISK_EVALUATION;
}

export class ReceiveCopyRiskEvaluation {
  public type: string = ACTION.RECEIVE_COPY_RISK_EVALUATION;
}
